import { useState } from 'react';
import { ApiError } from '../shell/api.js';

/**
 * One action on a slot card - keep, hide, branch, retry - with its refusal kept on the
 * card. A retry or a branch is refused in words when the chosen image source cannot make
 * it; a swallowed refusal leaves the old stopped line, as if nothing had been pressed.
 */
export function useSlotAction(onChanged: () => void): {
  busy: boolean;
  failure: string | null;
  act: (request: () => Promise<unknown>, fallback: string) => void;
} {
  const [busy, setBusy] = useState(false);
  const [failure, setFailure] = useState<string | null>(null);
  const act = (request: () => Promise<unknown>, fallback: string): void => {
    setBusy(true);
    setFailure(null);
    void request()
      .then(onChanged)
      .catch((caught: unknown) => setFailure(caught instanceof ApiError ? caught.message : fallback))
      .finally(() => setBusy(false));
  };
  return { busy, failure, act };
}
